// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ww7SNYLAYi063omYvxRS .SLXIuwdXl8ulyxSuazmz {
  padding: 6px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Ww7SNYLAYi063omYvxRS .vH9WGB61j19CFpS2QL6b {
  position: relative;
  padding-left: 16px;
}
.Ww7SNYLAYi063omYvxRS .vH9WGB61j19CFpS2QL6b .anticon {
  position: absolute;
  left: 0px;
  top: 4px;
  cursor: pointer;
  color: #999;
}
.Ww7SNYLAYi063omYvxRS .wTaNWW7DET3QjYCjavyy {
  margin-left: 16px;
}
.Ww7SNYLAYi063omYvxRS .BnyIPSzIIwhia9cNlLTo {
  margin-left: 32px;
}
.Ww7SNYLAYi063omYvxRS .vQqPqcfjDvFK811eQFS0 {
  font-weight: 500;
  color: #7d8592;
  line-height: 16px;
  background: #f5f6f8;
  border-radius: 4px;
  padding: 4px 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Task/Gantt/index.module.less"],"names":[],"mappings":"AACA;EAEI,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAJA;EAQI,kBAAA;EACA,kBAAA;AADJ;AARA;EAYQ,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;AADR;AAfA;EAqBI,iBAAA;AAHJ;AAlBA;EAwBI,iBAAA;AAHJ;AArBA;EA4BI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAJJ","sourcesContent":["\n.container {\n  .filter {\n    padding: 6px 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .taskName {\n    position: relative;\n    padding-left: 16px;\n    :global {\n      .anticon {\n        position: absolute;\n        left: 0px;\n        top: 4px;\n        cursor: pointer;\n        color: #999;\n      }\n    }\n  }\n  .nameLevel-2 {\n    margin-left: 16px;\n  }\n  .nameLevel-3 {\n    margin-left: 32px;\n  }\n\n  .taskNum {\n    font-weight: 500;\n    color: #7d8592;\n    line-height: 16px;\n    background: #f5f6f8;\n    border-radius: 4px;\n    padding: 4px 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Ww7SNYLAYi063omYvxRS`,
	"filter": `SLXIuwdXl8ulyxSuazmz`,
	"taskName": `vH9WGB61j19CFpS2QL6b`,
	"nameLevel-2": `wTaNWW7DET3QjYCjavyy`,
	"nameLevel-3": `BnyIPSzIIwhia9cNlLTo`,
	"taskNum": `vQqPqcfjDvFK811eQFS0`
};
export default ___CSS_LOADER_EXPORT___;
